import { createFileRoute } from "@tanstack/react-router";

import React from "react";
import { ACL } from "src/components/acl";
import { useTranslation } from "react-i18next";
import { Subheading } from "src/components/base/heading";
import SINGLE_TAG_CONTEXT from "src/context/internal/tag";
import ReadOnlyRuleSets from "src/components/rulesets";

/**
 * The properties for {@link TagOutboundACLs}
 */
export type TagOutboundACLsProps = {};

/**
 * The view to display the Outbound ACLs of a tag
 */
function TagOutboundACLs(props: TagOutboundACLsProps) {
    const [t] = useTranslation("admin-tag");

    const ctx = React.useContext(SINGLE_TAG_CONTEXT);

    return (
        <div className={"flex flex-col gap-6"}>
            {ctx.tag.locked ? undefined : (
                <>
                    <Subheading>{t("heading.add-new-acl")}</Subheading>
                    <ACL
                        key={"new-outbound"}
                        onChange={ctx.reset}
                        src={{ type: "Tag", value: ctx.tag }}
                        startEditable={true}
                    />
                </>
            )}

            <Subheading>{t("heading.existing-acls")}</Subheading>
            {ctx.tag.access_rules.outbound.map((acl) => (
                <ACL key={acl.uuid} src={acl.src} acl={acl} onChange={ctx.reset} />
            ))}
            <Subheading>{t("heading.rulesets")}</Subheading>
            {ctx.tag.rulesets.outbound.map((ruleset) => (
                <ReadOnlyRuleSets
                    key={ruleset.uuid}
                    name={ruleset.name}
                    description={ruleset.description}
                    rules={ruleset.rules}
                    sources={ruleset.src_or_dst}
                />
            ))}
        </div>
    );
}

export const Route = createFileRoute("/_admin/a/tags/$tagId/_tags/outbound-acls")({
    component: TagOutboundACLs,
});
